import React from "react";

/**
 * Mobile theme toggle. Mirrors the desktop ThemeToggle behavior so a saved
 * preference is the same key (`theme`) in localStorage and the same
 * `data-theme` attribute on <html>.
 */
export default function MobileThemeToggle() {
  const handleClick = () => {
    const html = document.documentElement;
    const current =
      html.getAttribute("data-theme") === "dark" ? "dark" : "light";
    const next = current === "dark" ? "light" : "dark";
    html.setAttribute("data-theme", next);
    try {
      localStorage.setItem("theme", next);
    } catch {
      // ignore
    }
  };

  return (
    <button
      type="button"
      className="m-theme-toggle"
      onClick={handleClick}
      aria-label="Toggle theme"
      title="Toggle theme"
    >
      <svg className="moon" viewBox="0 0 24 24" aria-hidden>
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
      <svg className="sun" viewBox="0 0 24 24" aria-hidden>
        <circle cx="12" cy="12" r="4" />
        <line x1="12" y1="2" x2="12" y2="4" />
        <line x1="12" y1="20" x2="12" y2="22" />
        <line x1="4.93" y1="4.93" x2="6.34" y2="6.34" />
        <line x1="17.66" y1="17.66" x2="19.07" y2="19.07" />
        <line x1="2" y1="12" x2="4" y2="12" />
        <line x1="20" y1="12" x2="22" y2="12" />
        <line x1="4.93" y1="19.07" x2="6.34" y2="17.66" />
        <line x1="17.66" y1="6.34" x2="19.07" y2="4.93" />
      </svg>
    </button>
  );
}
